module.exports = __webpack_public_path__ + "static/media/portfolio-5.502b25ba.jpg";